import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { Alert } from "../../../ui/organisms/alert"
import { Pagination } from "../../../ui/organisms/pagination"
import { formatterDate, optionsFormatter, ReportingStatusOption, ReportingTypologyOption, yearOptions } from "../../../utils"
import { SOTFilter } from "../../sot"
import { ReportingDTO } from "./dataService/dto"
import { GetAllReportings, ReportingDelete, resetGetAllReportingsFilters, resetReportingDeleteStatus, setGetAllReportingsFiltersHeadquarter, setGetAllReportingsFiltersPage, setGetAllReportingsFiltersReportingState, setGetAllReportingsFiltersYear, setReportingIdToUpdate, setReportingStateReportingId, setUpdateReportingCustomerOtherODC, setUpdateReportingDetails, setUpdateReportingEntryProtocolId, setUpdateReportingNote, setUpdateReportingReportingDate, setUpdateReportingReportingState, setUpdateReportingReportingType, setUpdateReportingSender } from "./slice"
import { handleState } from "./utils"

export function AllCustomersList() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const reportingState = useAppSelector(state => state.reporting)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [repToDelete, setRepToDelete] = useState<string | null>(null)

    const handleOnEdit = (data: ReportingDTO) => {
        dispatch(setReportingIdToUpdate(data.id))
        dispatch(setReportingStateReportingId(data.id))
        dispatch(setUpdateReportingReportingDate(data.reportingDate))
        dispatch(setUpdateReportingSender(data.sender))
        dispatch(setUpdateReportingCustomerOtherODC(data.customerOtherODC))
        dispatch(setUpdateReportingEntryProtocolId(data.entryProtocolId))
        dispatch(setUpdateReportingReportingState(data.reportingState))
        dispatch(setUpdateReportingReportingType(data.reportingType))
        dispatch(setUpdateReportingDetails(data.details))
        dispatch(setUpdateReportingNote(data.note))

        navigate('/editSegnalazione')
    }

    const handleOnHQ = (hq: string[]) => {
        if (hq === undefined || hq.length < 1)
            return null
        return (
            <ul>{hq.map(h => (<li>{h}</li>))}</ul> // DIVISI dA TRATTINI (TO DO)
        )
    }

    useEffect(() => {
        if (reportingState.reportingDeleteStatus === 'successfully') {
            dispatch(resetReportingDeleteStatus())
            dispatch(GetAllReportings({
                itemsPerPage: 0,
                page: 0,
                headquarter: reportingState.getAllReportingsFilters.headquarter,
                year: reportingState.getAllReportingsFilters.year,
                reportingState: reportingState.getAllReportingsFilters.reportingState,
            }))
        }
    }, [reportingState.reportingDeleteStatus])

    return (
        <div className="w-full p-4 flex flex-col">
            <div className="flex flex-col">
                <div className="grid grid-cols-1 xl:grid-cols-[1fr_auto] gap-4 items-end">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <MadfarmStaticSelect
                            isClearable
                            placeholder={'Anno'}
                            value={String(reportingState.getAllReportingsFilters.year)}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllReportingsFiltersYear(Number(newValue)))
                            }}
                            noOptionsMessage="Nessun anno disponibile"
                        />
                        <MadfarmStaticSelect
                            isClearable
                            placeholder={'Stato'}
                            value={reportingState.getAllReportingsFilters.reportingState}
                            options={ReportingStatusOption}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllReportingsFiltersReportingState(newValue))
                            }}
                            noOptionsMessage="Nessuno stato disponibile"
                        />
                        <SOTFilter
                            key={reportingState.getAllReportingsFilters.headquarter || 'default'}
                            value={reportingState.getAllReportingsFilters.headquarter}
                            onChange={(value) => dispatch(setGetAllReportingsFiltersHeadquarter(value))}
                        />
                    </div>

                    <div className="flex gap-3 justify-end">
                        <ButtonComponent
                            size="lg"
                            iconPosition="off"
                            variant="outline"
                            label="Pulisci"
                            color="gray"
                            onClick={() => dispatch(resetGetAllReportingsFilters())}
                        />
                        <ButtonComponent
                            variant="outline"
                            color="orange"
                            size="lg"
                            iconPosition="off"
                            label="Cerca"
                            onClick={() => dispatch(GetAllReportings({
                                itemsPerPage: 30,
                                page: reportingState.getAllReportingsFilters.page,
                                headquarter: reportingState.getAllReportingsFilters.headquarter,
                                year: reportingState.getAllReportingsFilters.year,
                                reportingState: reportingState.getAllReportingsFilters.reportingState,
                            }))}
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <Pagination
                        numbResults={reportingState.getAllReportingsResponse ? reportingState.getAllReportingsResponse.total : 0}
                        detailsResults={'Segnalazioni'}
                        fullWidth={false}
                        pages={reportingState.getAllReportingsResponse?.totalPage || 1}
                        currentPage={reportingState.getAllReportingsFilters.page ? reportingState.getAllReportingsFilters.page : 0}
                        setPage={(page) => dispatch(setGetAllReportingsFiltersPage(page))}
                    />
                </div>
            </div>

            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Sede</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data segnalazione</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Mittente</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente altro ODC</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo entrata</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Stato</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(reportingState.getAllReportingsResponse?.data || []).length === 0 ? (
                            <tr>
                                <td colSpan={11} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                    Nessuna segnalazione trovata
                                </td>
                            </tr>
                        ) : (
                            reportingState.getAllReportingsResponse?.data.map((rep, index) => (
                                <tr
                                    key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700">
                                        {handleOnHQ(rep.customerHeadQuarters!)}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap w-[15%]">
                                        {rep.customerInfo}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                        {formatterDate(rep.reportingDate)}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {rep.sender}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {rep.customerOtherODC}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {rep.entryProtocolInfo}
                                    </td>
                                    <td className="px-3 py-2 text-center">
                                        <div className="flex justify-center">
                                            {handleState(rep.reportingState)}
                                        </div>
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {rep.officerInfo}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {'Da stabilire'}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {optionsFormatter(rep.reportingType, ReportingTypologyOption)}
                                    </td>
                                    <td className="px-3 py-2 w-[60px]">
                                        <div className="flex items-center justify-center gap-2">
                                            <button
                                                className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                onClick={() => handleOnEdit(rep)}
                                            >
                                                <EditIcon color="orange" size={20} />
                                                <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                    Modifica Segnalazione
                                                </span>
                                            </button>
                                            <button
                                                className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                onClick={() => {
                                                    setRepToDelete(rep.id)
                                                    setShowAlert(true)
                                                }}
                                            >
                                                <TrashIcon color="orange" size={20} />
                                                <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                    Elimina Segnalazione
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {
                (showAlert && repToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare la segnalazione?
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ButtonComponent
                                    variant="outline"
                                    color="gray"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <ButtonComponent
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(ReportingDelete(repToDelete))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
        </div>
    )
}